function initFontResize() {
  const textBlock = document.querySelector(".js-resizable-text");
  const classes = ["font-small", "font-medium", "font-large", "font-extra-large"];
  let current = parseInt(localStorage.getItem("fontSizeLevel") || "0", 10);
  
  function updateFontClass() {
    if (textBlock !== null) {
      textBlock.className = "resizable-text js-resizable-text " + classes[current];
      localStorage.setItem("fontSizeLevel", current);
    }
  }
  
  const increaseBtn = document.querySelector(".js-increase-font");
  const decreaseBtn = document.querySelector(".js-decrease-font");
  
  if (increaseBtn && decreaseBtn && textBlock) {
    increaseBtn.onclick = () => {
      if (current < classes.length - 1) {
        current++;
        updateFontClass();
      }
    };
    
    decreaseBtn.onclick = () => {
      if (current > 0) {
        current--;
        updateFontClass();
      }
    };
    
    updateFontClass();
  }
}

document.addEventListener("DOMContentLoaded", initFontResize);

document.addEventListener("turbolinks:load", initFontResize);
